import React from "react"
import { Grid, Header } from "semantic-ui-react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { graphql, useStaticQuery } from "gatsby"

const TryDemo = ({ isMobile }) => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/devices.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1500)
        }
      }
      app: file(relativePath: { eq: "home/app_store.png" }) {
        childImageSharp {
          gatsbyImageData(width: 300)
        }
      }
      play: file(relativePath: { eq: "home/google_play.png" }) {
        childImageSharp {
          gatsbyImageData(width: 300)
        }
      }
    }
  `)
  return (
    <Grid
      stackable
      style={{ padding: isMobile ? "2em" : "2em", textAlign: "center" }}
    >
      <Grid.Row centered>
        <Grid.Column width={8}>
          <GatsbyImage
            style={{ margin: "1rem", maxHeight: 600 }}
            imgStyle={{ objectFit: "contain" }}
            image={getImage(data.image)}
            alt="A computer, tablet, and phone showing the native ArtCollection.io applications."
          />
        </Grid.Column>
        <Grid.Column
          width={8}
          verticalAlign={"middle"}
          textAlign={"left"}
          floated={"left"}
        >
          <Header
            as={"h2"}
            size={"huge"}
            content={"Available on any device, mac, pc & more"}
          />
          <p>
            ArtCollection.io is a cloud based solution that gives you access to
            your collection anywhere you have a secure internet connection. In
            addition to a beautiful web dashboard, we also provide users with a
            suite of mobile applications that allow for data synchronization and
            offline browsing. Feel confident in your ability to access your art
            collection anywhere around the world at anytime. Download
            ArtCollection.io today!
          </p>
          <div>
            <a
              href="https://itunes.apple.com/app/id1340740560"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={getImage(data.app)}
                alt="App Store button to download iOS application."
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=artcollection.io.artcollection"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={getImage(data.play)}
                alt="Google Play Button to download Android application."
              />
            </a>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
export default TryDemo
